// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AddConsultingCaseRequestModel from '../../model/add-consulting-case-request-model';
import AddConsultingCaseRequestDTO from '../dto/add-consulting-case-request-dto';
import dtoSchema from '../schemas/add-consulting-case-request-schema';

export default abstract class AddConsultingCaseRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AddConsultingCaseRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.subject = data.subject ?? undefined;
      this.description = data.description ?? undefined;
      this.documents = data.documents ?? undefined;
      this.customerContactText = data.customerContactText ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  */
  subject?: string;
  /**
  */
  description?: string;
  /**
  */
  documents?: string[];
  /**
  */
  customerContactText?: string;

  static toModel(dto: DeepPartial<AddConsultingCaseRequestDTO>): AddConsultingCaseRequestModel;
  static toModel(dto: DeepPartial<AddConsultingCaseRequestDTO> | undefined | null): AddConsultingCaseRequestModel | undefined;
  static toModel(dto: DeepPartial<AddConsultingCaseRequestDTO> | undefined | null): AddConsultingCaseRequestModel | undefined {
    return dto ? new AddConsultingCaseRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AddConsultingCaseRequestModel> | AddConsultingCaseRequestModel): AddConsultingCaseRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
      subject: unwrapped.subject,
      description: unwrapped.description,
      documents: unwrapped.documents,
      customerContactText: unwrapped.customerContactText,
    } as AddConsultingCaseRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AddConsultingCaseRequestModel, can not map to AddConsultingCaseRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
